import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSignOut = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14 5C14 4.44772 13.5523 4 13 4H6L5.85074 4.00549C4.81588 4.08183 4 4.94564 4 6V26L4.00549 26.1493C4.08183 27.1841 4.94564 28 6 28H13L13.1166 27.9933C13.614 27.9355 14 27.5128 14 27C14 26.4477 13.5523 26 13 26H6V6H13L13.1166 5.99327C13.614 5.93551 14 5.51284 14 5ZM22.4586 10.043L22.3644 9.95978C21.9721 9.65471 21.4049 9.68236 21.0444 10.0428L20.9612 10.137C20.6561 10.5292 20.6837 11.0965 21.0442 11.457L24.585 15H13L12.8834 15.0067C12.386 15.0645 12 15.4872 12 16C12 16.5523 12.4477 17 13 17H24.585L21.0442 20.543L20.961 20.6372C20.656 21.0295 20.6838 21.5968 21.0444 21.9572C21.4349 22.3477 22.0681 22.3476 22.4586 21.957L27.7072 16.707L27.7904 16.6128C28.0953 16.2206 28.0676 15.6535 27.7072 15.293L22.4586 10.043Z"
	})
});
export default SvgSignOut;
